import { AuthTypes, defaultAuthPayload } from "../../types/auth";

export const logout = (dispatch: any) => (): void => {
    dispatch({ type: AuthTypes.logout, payload: defaultAuthPayload });
}